import React from 'react'
import { AdvanceSelect } from '../_atoms/_index'
import { FormGroup } from 'reactstrap'
import styled from 'styled-components'

export const InputTitle = styled.label`
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: var(--text-heading);
  text-align: left;
  float: left;
`
export const SelectLabel = styled.label`
  font-size: 9px;
`

const AdvanceSelectFormGroup = ({ labelText, selectProps, labelColor, profile }) => {
  return (
    <>
      <FormGroup className={`${profile ? 'd-flex flex-column' : ''}`}>
        {profile ? (
          <InputTitle>{labelText}</InputTitle>
        ) : (
          <SelectLabel
            className={`form-label ${
              labelColor === null || labelColor === undefined ? 'text-muted' : labelColor
            }`}
            for={selectProps.id}>
            {labelText}
          </SelectLabel>
        )}
        <AdvanceSelect {...selectProps} />
      </FormGroup>
    </>
  )
}

export default AdvanceSelectFormGroup
